import { API_REQUEST } from 'redux-api-request/dist/action_types'

export const get = () => ({
  type: API_REQUEST,
  method: 'GET',
  endpoint: '/api/account',
  // body: { email, password },
  request: 'ACCOUNT_GET_REQUEST',
  success: 'ACCOUNT_GET_SUCCESS',
  failure: 'ACCOUNT_GET_FAILURE',
})

export const update = (id, props) => ({
	type: API_REQUEST,
	method: 'PUT',
	endpoint: '/api/account',
	body: props,
	request: 'ACCOUNT_UPDATE_REQUEST',
	success: 'ACCOUNT_UPDATE_SUCCESS',
	failure: 'ACCOUNT_UPDATE_ERROR',
})

export const editStart = () => ({
  type: 'EDIT_ACCOUNT_START',
})

export const editCancel = () => ({
  type: 'EDIT_ACCOUNT_CANCEL',
})
 



// WEBPACK FOOTER //
// ./src/modules/account/account.actions.js